import { CATALOG_WEAPON_STATS } from './catalog';

export function hash32(...parts: Array<number | string>) {
  let h = 2166136261;
  for (const part of parts) {
    if (typeof part === 'number') {
      const n = part >>> 0;
      h ^= n & 0xff;
      h = Math.imul(h, 16777619);
      h ^= (n >>> 8) & 0xff;
      h = Math.imul(h, 16777619);
      h ^= (n >>> 16) & 0xff;
      h = Math.imul(h, 16777619);
      h ^= (n >>> 24) & 0xff;
      h = Math.imul(h, 16777619);
    } else {
      const s = String(part);
      for (let i = 0; i < s.length; i++) {
        h ^= s.charCodeAt(i);
        h = Math.imul(h, 16777619);
      }
    }
  }
  return h >>> 0;
}

export function uniform01(combatSeed: number, geodeId: string | number, tapIndex: number) {
  const h = hash32(combatSeed >>> 0, String(geodeId), tapIndex >>> 0);
  return (Math.imul(h, 2654435761) >>> 0) / 4294967296;
}

export function getWeaponCombatStats(weaponName: string) {
  return CATALOG_WEAPON_STATS[weaponName] ?? CATALOG_WEAPON_STATS.WoodClub;
}

export function tapDamage(
  combatSeed: number,
  geodeId: string | number,
  tapIndex: number,
  weaponName: string,
) {
  const stats = getWeaponCombatStats(weaponName);
  const u = uniform01(combatSeed, geodeId, tapIndex);
  const variance = (100 - stats.precision) / 100;
  const multiplier = 1 + (2 * u - 1) * variance;
  return stats.damage * multiplier;
}
